/* global fbq */
import { createContext } from "react";
import { toast } from "react-toastify";
import { makeid } from "../helper/StringHelper";
import AxiosHelper from '../helper/AxiosHelper'
import { useState } from "react";
import { useEffect } from "react";
import { useCallback } from "react";

var session_id = localStorage.getItem('session_id');

const getSessionId = () => {
    session_id = localStorage.getItem('session_id');
}

const getCartPayload = (forceCreateSession = false) => {
    getSessionId();

    if (!session_id && forceCreateSession) {
        session_id = makeid(30)
        localStorage.setItem('session_id', session_id);
    }

    return session_id ? { session_id } : {}
}

const addToCart = async (product_id, price, quantity = 1, attributes = '') => {
    const cartPayload = getCartPayload(true);
    var { data } = await AxiosHelper.postData(`/addtocart`, { product_id, quantity, attributes, ...cartPayload });    
    if (data.status === true) {
         // Facebook Pixel tracking script
				 if (typeof fbq === "function") {

                const eventID = "sh-" + crypto.randomUUID();
					fbq('track', 'AddToCart', {
							value: (price*quantity) || 0,
							currency: 'INR',
                            content_type:'product',
							contents: [
									{
											id: product_id,
											quantity: quantity,
                                            currency:'INR',
                                            item_price:price
									}
							],
							content_ids: [product_id],
                            num_items:quantity
					},
                { eventID }
                );
			} else {
					console.warn("Facebook Pixel is not loaded or fbq is not defined.");
			}	 

        toast.success('Product added to cart successfully.')
        return true;
    }


    toast.error(data.message)
    return false;
}

const updateCart = async (quantity, cart_id) => {
    const cartPayload = getCartPayload(true);
    var { data } = await AxiosHelper.postData(`/updatecartitem`, { quantity, cart_id, ...cartPayload });
    if (data.status === true) {
        return true;
    }

    toast.error(data.message)
    return false;
}

const removeItemFromCart = async (cart_id) => {
    const cartPayload = getCartPayload(true);
    var { data } = await AxiosHelper.postData(`/removecart`, { cart_id, ...cartPayload });
    if (data.status === true) {
        return true;
    }

    toast.error(data.message)
    return false;
}

const applyCoupon = async (coupon) => {
    const cartPayload = getCartPayload(true);
    var { data } = await AxiosHelper.postData("/checkcoupon", { coupon, ...cartPayload });
    if (data.status === true) {
        toast.success(data?.message)
        return true;
    } else {
        toast.error(data?.message)
        return false;
    }
}



const userData = { addToCart, updateCart, removeItemFromCart, applyCoupon }

const CartProvider = (props) => {
    const [getCart, setGetCart] = useState({
        warning: "",
        products: [],
        totals: [],
        cart_total: 0
    })

    const getCartData = useCallback(() => {
        (async () => {
            const cartPayload = getCartPayload();
            if (cartPayload.session_id) {
                var { data } = await AxiosHelper.postData(`/getcart`, cartPayload);
                if (data.success === true) {
                    setGetCart(data.data);
                }
            }
            return false;
        })()
    }, [])

const applyReward = async () => {
    const cartPayload = getCartPayload();
    var { data } = await AxiosHelper.postData("/getcart", { use_reward_points:1, ...cartPayload });
    
    if (data.success === true) {
        setGetCart(data.data);
        return data;

    } else {
        toast.error(data?.message)
        return data;
    }
}

const deliveryEstimate = async (params) => {
    var { data } = await AxiosHelper.postData(`/delivery-estimate`, params);
    if (data.status === true) {
        return data;
    }

    toast.error(data.message)
    return false;
}


    useEffect(() => {
        getCartData()
    }, [getCartData])

    const updateMyCart = () => {
        getCartData()
    }

    return (
        <cartData.Provider value={{ ...userData, getCart, updateMyCart, applyReward,deliveryEstimate }}>
            {props.children}
        </cartData.Provider>
    )
}

export const cartData = createContext(userData)
export default CartProvider
